<section class="web-entity-home-section">
  <div class="trapeze"></div>

  <div class="web-entity-home-section__bg">
    <fr8bot-web-video-autoplay [src]="videoSrc()" [poster]="posterSrc()" [priority]="true" />

    <div class="web-entity-home-section__bg-blur"></div>
  </div>

  <div class="web-entity-home-section__inner">
    <div class="web-entity-home-section__inner-header">
      <h1 class="web-entity-home-section__inner-header-title">
        <ng-content select="[title]"></ng-content>
      </h1>

      <p class="web-entity-home-section__inner-header-subtitle">
        <ng-content select="[description]"></ng-content>
      </p>
    </div>

    <div class="web-entity-home-section__inner-actions">
      <div class="web-entity-home-section__inner-actions-buttons">
        <ng-content select="[actions]"></ng-content>
      </div>

      <p class="web-entity-home-section__inner-actions-label">
        <ng-content select="[label]"></ng-content>
      </p>
    </div>
  </div>
</section>
